// apiWrapper.ts
// ———————————————————————————————————————————————————————————————
// Wrappers para llamadas directas a la API SCORM
// ———————————————————————————————————————————————————————————————

import type { ScormAPI, SCORM12API, SCORM2004API, Version } from './types';

/**
 * Wrapper para Initialize/LMSInitialize
 */
export function apiInit(api: ScormAPI, version: Version): boolean {
  if (!api) return false;

  try {
    const result = version === "2004"
      ? (api as SCORM2004API).Initialize("")
      : (api as SCORM12API).LMSInitialize("");

    console.log(`[SCORM] Initialize: ${result}`);
    return result === "true";
  } catch (e) {
    console.error("[SCORM] Initialize error:", e);
    return false;
  }
}

/**
 * Wrapper para Terminate/LMSFinish
 */
export function apiFinish(api: ScormAPI, version: Version): boolean {
  if (!api) return false;

  try {
    const result = version === "2004"
      ? (api as SCORM2004API).Terminate("")
      : (api as SCORM12API).LMSFinish("");

    console.log(`[SCORM] Finish: ${result}`);
    return result === "true";
  } catch (e) {
    console.error("[SCORM] Finish error:", e);
    return false;
  }
}

/**
 * Wrapper para GetValue/LMSGetValue
 */
export function apiGet(api: ScormAPI, version: Version, element: string): string {
  if (!api) return "";

  try {
    const result = version === "2004"
      ? (api as SCORM2004API).GetValue(element)
      : (api as SCORM12API).LMSGetValue(element);

    return result ?? "";
  } catch (e) {
    console.error(`[SCORM] GetValue(${element}) error:`, e);
    return "";
  }
}

/**
 * Wrapper para SetValue/LMSSetValue
 */
export function apiSet(api: ScormAPI, version: Version, element: string, value: string): boolean {
  if (!api) return false;

  try {
    const result = version === "2004"
      ? (api as SCORM2004API).SetValue(element, value)
      : (api as SCORM12API).LMSSetValue(element, value);

    const success = result === "true";

    if (!success) {
      const errorCode = apiGetLastError(api, version);
      console.error(`[SCORM] SetValue(${element}) FAILED. Error: ${errorCode}`);
    }

    return success;
  } catch (e) {
    console.error(`[SCORM] SetValue(${element}) error:`, e);
    return false;
  }
}

/**
 * Wrapper para Commit/LMSCommit
 */
export function apiCommit(api: ScormAPI, version: Version): boolean {
  if (!api) return false;

  try {
    const result = version === "2004"
      ? (api as SCORM2004API).Commit("")
      : (api as SCORM12API).LMSCommit("");

    console.log(`[SCORM] Commit: ${result}`);
    return result === "true";
  } catch (e) {
    console.error("[SCORM] Commit error:", e);
    return false;
  }
}

/**
 * Wrapper para GetLastError/LMSGetLastError
 */
export function apiGetLastError(api: ScormAPI, version: Version): string {
  if (!api) return "0";

  try {
    return version === "2004"
      ? (api as SCORM2004API).GetLastError()
      : (api as SCORM12API).LMSGetLastError();
  } catch {
    return "0";
  }
}
